module.exports = __webpack_public_path__ + "static/media/img-made-thumb.d844c63e.png";